import React, { Fragment, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import FormValidator from '../../../inc/FormValidator';
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import Collapse from '../../inc/Collapse';
import FieldsRenderer from '../../Purchase Orders Internal/Edit PO/FieldsRenderer';
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings';
import { areObjectsDifferent, getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Helper from '../../../inc/Helper';
import NavigationHeder from '../../Navigations/NavigationHeder';
import LinkBtn from '../../inc/LinkBtn';
import Button from '../../inc/Button';
import SimpleLoading from '../../Loading/SimpleLoading';

let defaultAppFormsObject = null;
const AppFormsDetailView = () => {
    const [appFormsData, setAppFormsData] = useState({});

    const { id } = useParams();

    const [loading, setLoading] = useState(true); 
   
    let getByIdApiCall = false; 
  
    useEffect(() => { 
        getAppFormsById();
    }, [])
  
    let validator; 
  
    const validationConfigure = () => {
        let fieldConfig = [ 
            {name:'name', displayName: 'Name', types:['Required']},
            {name:'redirect_uri', displayName: 'Redirect URI', types:['Required']}
        ];

        if(!validator) {
            validator = new FormValidator(fieldConfig)
        }
    }

    validationConfigure()
  
    const getAppFormsById = () => { 
        if(getByIdApiCall) return;

        getByIdApiCall = true;
        setLoading(true);

        let api = Api
        api.setUserToken()
        api.axios().get(Settings.apiAppUrl+`/app/${id}/`,{}).then(function(res){
            if(res?.status === 200){ 
                setAppFormsData(res?.data);
                defaultAppFormsObject = res?.data;
                setLoading(false);
            } else {
                Helper.alert(res?.data?.message, 'error')
            }
        }).catch((res) => { 
            getPopupMessageBasedOnStatus(res) 
            setLoading(false)
        })
    }
 
    const AppFormsDetailView = () => { 
        let textBoxInputSettings = [
            {className:'col-lg-4', required: true, label: "Name", inputType: "text", id:'name', name:'name'},
            {className:'col-lg-4', required: true, label: "Redirect URI", inputType: "text", id:'redirect_uri', name:'redirect_uri'}
        ];
  
        return (
            <Collapse open={true} title={"General"}>
                <div className='row mb-3'>
                    <FieldsRenderer fieldsArray={textBoxInputSettings} updateState={setAppFormsData} currentState={appFormsData} />
                </div>
            </Collapse>
        )
    }
 
    const SaveHandler = () => {
        if(!areObjectsDifferent(defaultAppFormsObject, appFormsData)) return;
        
        let validData = {
            ...appFormsData
        };

        if(!validator.isValid(validData)){
            validator.displayMessage();
            validator.reset() 
            return;
        };

        let api = Api;
        api.setUserToken();

        api.axios().put(Settings.apiAppUrl+`/app/${id}/`, appFormsData).then(function(res){
            if(res?.status === 200){
                Helper.alert(res?.data?.message || 'App updated successfully', 'success');
                getAppFormsById();
            } else {
                Helper.alert(res?.data?.message, 'error')
            }
        }).catch((res) => {  
            getPopupMessageBasedOnStatus(res);
        })  
    }
  
    return (  
        <div className='container-fluid'>
            <NavigationHeder title={ `<span style="color:#000;"> Edit App #</span> ${appFormsData?.name}` }>
                <LinkBtn to={-1} isActive= {false} title={"Close"} />
                <Button isActive= {true} onClick ={SaveHandler} title={"Save"} icon={'/images/icons/save-white.svg'} />
            </NavigationHeder>
     
            {loading ? <SimpleLoading /> : (
                <Fragment>
                    {AppFormsDetailView()} 
                </Fragment>
            )} 
        </div>
    )
}

export default (MasterComponentWraper(AppFormsDetailView));